{
  "comment": "M3 in-system layout tuning (plan §5 R4; spec §3, §4.1, §4.3). System frame: float64 metres, star at the origin, y up. Every value is a starting value, tune freely. anchors: station lists that replace the archetype roll (a region whose regionStationScale is 0 still gets none). homeCluster offsets are relative to the M1 frame origin and equal M2's stations.json positions; their bays face the spawn; extraServices adds services on top of the type's (the Charter Hub's lease-office, M2's lease; no station type may list lease-office). lanes.shellClearanceM keeps lane rings clear of body shells; lanes.downChance is per region.",
  "stars": { "radiusM": { "O": 9e8, "B": 8e8, "A": 7e8, "F": 6e8, "G": 5e8, "K": 4e8, "M": 3e8 } },
  "bodies": { "shellFactor": 1.05, "shellExtraM": 20000, "tiltDeg": 25 },
  "stationTypes": {
    "hub": { "assetId": "reach.station_hub", "label": "Hub", "services": ["market", "repair", "outfitting", "contracts", "chart-buyer", "parts-vendor"], "m2Role": "hub", "factions": ["authority", "mutual"] },
    "refinery": { "assetId": "reach.station_refinery", "label": "Refinery", "services": ["market", "repair", "outfitting", "contracts"], "m2Role": "refinery", "factions": ["tethys"] },
    "scrapyard": { "assetId": "reach.station_scrapyard", "label": "Scrapyard", "services": ["market", "repair", "outfitting", "contracts"], "m2Role": "scrapyard", "factions": ["mutual", "varro_security"] },
    "trade-post": { "assetId": "reach.station_trade", "label": "Trade Post", "services": ["market", "contracts", "chart-buyer", "parts-vendor"], "m2Role": "hub", "factions": ["meridian"] },
    "outpost": { "assetId": "reach.station_outpost", "label": "Outpost", "services": ["market", "repair"], "m2Role": "scrapyard", "factions": ["mutual", "holdfast", "tethys"] },
    "habitat": { "assetId": "reach.station_habitat", "label": "Habitat", "services": ["market", "repair", "contracts", "parts-vendor"], "m2Role": "hub", "factions": ["holdfast"] },
    "patrol-base": { "assetId": "reach.station_patrol", "label": "Patrol Base", "services": ["repair", "contracts", "chart-buyer"], "m2Role": "hub", "factions": ["authority", "varro_security"] }
  },
  "archetypeStations": {
    "mining-belt": { "count": [1, 3], "types": { "refinery": 3, "outpost": 2, "hub": 1 } },
    "ice-field": { "count": [1, 2], "types": { "outpost": 2, "refinery": 1, "hub": 1 } },
    "gas-harvest": { "count": [1, 2], "types": { "refinery": 2, "outpost": 2 } },
    "industrial-hub": { "count": [2, 4], "types": { "refinery": 2, "hub": 2, "scrapyard": 1, "trade-post": 1 } },
    "trade-crossroads": { "count": [2, 4], "types": { "trade-post": 3, "hub": 2, "scrapyard": 1 } },
    "derelict-graveyard": { "count": [1, 2], "types": { "scrapyard": 3, "outpost": 1 } },
    "raider-haven": { "count": [0, 1], "types": { "outpost": 1 } },
    "descendant-enclave": { "count": [1, 2], "types": { "habitat": 3, "outpost": 1 } },
    "tetherstone-vein": { "count": [1, 2], "types": { "refinery": 2, "outpost": 1 } },
    "chokepoint": { "count": [1, 2], "types": { "patrol-base": 3, "outpost": 1 } }
  },
  "regionStationScale": { "gate": 1.25, "mid": 1, "deep": 0.75, "rim": 0 },
  "minStations": { "gate": 1, "mid": 1, "deep": 0, "rim": 0 },
  "factionFloor": 0.05,
  "placement": {
    "anchorWeights": { "body": 0.6, "field": 0.3, "free": 0.1 },
    "bodyAltitudeFactor": [1.5, 3],
    "bodyAltitudeMinM": 300000,
    "fieldEdgeOffsetM": 30000,
    "freeOrbitM": [3e9, 3.5e10],
    "minSeparationM": 50000,
    "maxTries": 40
  },
  "anchors": {
    "authority-seat": ["hub", "patrol-base", "trade-post"],
    "megacorp-hq": ["refinery", "refinery", "hub"],
    "descendant-capital": ["habitat", "habitat", "outpost"],
    "okafor-hideout": ["outpost"],
    "guardian-base": [],
    "home-gate": []
  },
  "homeCluster": {
    "fieldIndex": 0,
    "stations": [
      { "type": "hub", "faction": "authority", "name": "Charter Hub", "offset": [-3000, 300, -13200], "specialty": "ice", "extraServices": ["lease-office"] },
      { "type": "refinery", "faction": "tethys", "name": "Tethys Refinery", "offset": [11000, -400, -5000], "specialty": "ores" },
      { "type": "scrapyard", "faction": "mutual", "name": "Mutual Scrapyard", "offset": [-13600, 600, -1000], "specialty": "components" }
    ],
    "spawnOffset": [0, 0, 0]
  },
  "relays": { "orbitFraction": [0.82, 0.9], "minSeparationDeg": 25, "yJitterM": 2e9, "apertureM": 180,
    "shellClearanceM": 100000,
    "shellStepDeg": 0.5 },
  "lanes": {
    "archetypes": ["trade-crossroads", "industrial-hub"],
    "anchors": ["authority-seat", "megacorp-hq", "home-gate"],
    "factions": ["authority", "tethys", "meridian"],
    "maxLanes": 3,
    "ringsPerLane": [3, 7],
    "endClearanceM": 50000,
    "minLengthM": 1e9,
    "apertureM": 50,
    "shellClearanceM": 1000,
    "downChance": { "gate": 0, "mid": 0.1, "deep": 0.25, "rim": 0 }
  },
  "danger": {
    "region": { "gate": 0.3, "mid": 1, "deep": 1.5, "rim": 2 },
    "archetype": { "raider-haven": 1.5, "chokepoint": 1.2, "industrial-hub": 0.9, "trade-crossroads": 0.8 },
    "anchor": { "home-gate": 0.5, "authority-seat": 0.5 }
  },
  "pois": {
    "assetByKind": { "cache": "reach.cache", "anomaly": "reach.anomaly", "nav-beacon": "reach.beacon", "hidden-base": "reach.base_raider", "derelict": null },
    "guardianBaseAsset": "reach.base_guardian",
    "clearanceM": 100000,
    "starClearanceFactor": 3
  }
}
